module.exports = __webpack_public_path__ + "static/media/brookfield-logo.504f3357.svg";